export { default } from './ContentTypesTable'